import { useState } from "react";

import {
  Loader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import "./remove-instructor.modal.scss";

const getInstructorName = (instructors) => {
  if (instructors?.length === 1) {
    return `${instructors[0]?.firstName} ${instructors[0]?.lastName}`.trim();
  }
  return ` ${instructors?.length} instructors`;
};

export function RemoveInstructorModal({
  open,
  onCancel,
  onRemoveInstructor,
  instructors,
  classroom,
}) {
  const [loading, setLoading] = useState();

  const onCloseHandler = () => {
    onCancel && onCancel();
  };

  const onRemoveInstructorHandler = () => {
    setLoading(true);
    onRemoveInstructor &&
      onRemoveInstructor(instructors, classroom).finally(setLoading);
  };

  return (
    <Modal
      modalClassName="remove-instructor-modal"
      open={open}
      onClose={onCloseHandler}
      preventClose={loading}
    >
      {loading && <Loader overlay></Loader>}
      <ModalHeader
        className="red-icon"
        icon={["fa-light", "user-xmark"]}
        title="Remove Instructor"
      ></ModalHeader>
      <ModalBody>
        Are you sure you would like to remove{" "}
        <strong>{getInstructorName(instructors)}</strong> from{" "}
        <strong>{classroom.name}</strong> ?
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCloseHandler} disabled={loading}>
          No, Cancel
        </Button>
        <Button
          destructive
          onClick={onRemoveInstructorHandler}
          disabled={loading}
        >
          Yes, Remove
        </Button>
      </ModalFooter>
    </Modal>
  );
}
